var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.root},_vm._l((_vm.links),function(link){
var _obj;
return _c('li',{key:link.value},[_c('a',{class:( _obj = {}, _obj[_vm.$style.link] = true, _obj[_vm.$style.bold] = _vm.isAuthenticated, _obj ),attrs:{"href":link.path}},[_vm._v("\n      "+_vm._s(_vm.$t(link.value))+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }